// Leads — subpagina op Orders (vraag 16-09-2026).
//
// Een lead is een order in een van de eerste Opp. Stages — "New (st.)" en
// "Acq. (st.)" / "Acq. (cu.)" (acquisitie), met hun varianten: een klant die
// het onboardingformulier begonnen is en niet heeft afgemaakt. De ET-API kent daar geen aparte feed voor: /orders levert álle
// orders, dus de leads zitten al in de gescopete orderlijst van de gebruiker —
// de rechten (energielabel / team / verkoper) gelden dus vanzelf, precies zoals
// op de tab Orders.
//
// Twee vaste regels bovenop de gewone filters:
//   1. EAN-ontdubbeling (altijd aan): staat dezelfde EAN óók in een andere order
//      die géén lead is, dan is dit geen lead maar een (foutieve) her-invoer —
//      de klant is al klant of zit al in het proces. Staan er meerdere leads op
//      dezelfde EAN, dan blijft alleen de meest recente over.
//   2. Bron: Totaal / Reseller / Online, standaard Online = geen verkoper
//      toegekend (of het systeemaccount OdooBot), want die klanten zijn zelf
//      begonnen en heeft nog niemand opgepikt.
//
// Beperking die bij de scope hoort: een teamleader/verkoper ziet alleen zijn
// eigen orders, dus een EAN die bij een ANDERE verkoper al actief is, kan hij
// niet als her-invoer herkennen. Admin, ET en master zien het label volledig.

export const LEAD_STAGE = /^\s*(new|acq)\b/i;
export const LEADS_BRONNEN = [
  { id: 'online', label: 'Online' },
  { id: 'reseller', label: 'Reseller' },
  { id: 'totaal', label: 'Totaal' },
];

export const isLeadStage = (stage) => LEAD_STAGE.test(String(stage || ''));
// Geen verkoper, of het systeem-/online-account (zelfde regel als applyOnlineOrderRules).
export const isOnlineOrder = (o) => {
  const s = String((o && o.salesperson) || '').trim();
  return !s || /^(online|odoobot)$/i.test(s);
};

const tijd = (o) => String((o && (o.orderDateTime || o.orderDate)) || '');
const ean = (o) => String((o && o.connectionPointGSRN) || '').trim();

// De leads uit een (gescopete) orderlijst.
export function bepaalLeads(orders, bron = 'online') {
  const lijst = Array.isArray(orders) ? orders : [];
  // EAN's die in een niet-lead-order voorkomen: her-invoer, geen lead.
  const bezet = new Set();
  for (const o of lijst) { if (!isLeadStage(o.opportunityStage)) { const g = ean(o); if (g) bezet.add(g); } }
  // Per EAN alleen de meest recente lead.
  const perEan = new Map();
  const zonderEan = [];
  for (const o of lijst) {
    if (!isLeadStage(o.opportunityStage)) continue;
    const g = ean(o);
    if (g && bezet.has(g)) continue;
    if (!g) { zonderEan.push(o); continue; }
    const huidig = perEan.get(g);
    if (!huidig || tijd(o) > tijd(huidig)) perEan.set(g, o);
  }
  let leads = [...perEan.values(), ...zonderEan];
  if (bron === 'online') leads = leads.filter(isOnlineOrder);
  else if (bron === 'reseller') leads = leads.filter((o) => !isOnlineOrder(o));
  return leads.sort((a, b) => tijd(b).localeCompare(tijd(a)));
}
